import React, {Component} from 'react';
import {connect} from 'react-redux';
import find from 'lodash/find';

import {getAvailableChunks} from '../../../general/selectors';
import {animationIndex} from '../../../general/actionCreators';

class Animator extends Component {

    constructor(props) {
        super(props);

        this.timer = 0;
    }

    render() {
        return null;
    }

    componentDidUpdate({isAnimating}) {
        if (this.props.isDragging) this.clearTimeout();
        else if (this.props.isAnimating) this.setTimeout(isAnimating === false);
        else if (isAnimating) this.clearTimeout();
    }

    setTimeout(immediate) {
        this.clearTimeout();

        const {index, availableChunks, loaded, speed, changeIndex} = this.props;
        const nextChunk = this.constructor.getNextChunk(index, availableChunks, loaded);

        if (nextChunk === null) return;

        const delay = this.constructor.getDelay(speed, immediate);

        this.timer = window.setTimeout(
            () => changeIndex(nextChunk.index),
            nextChunk.index < index ? delay * 2 : delay
        );
    }

    clearTimeout() {
        if (this.timer) {
            window.clearTimeout(this.timer);
            this.timer = 0;
        }
    }

    static getDelay(speed, immediate) {
        if (immediate) return 0;

        return 60 + (100 - speed) / 5 * 60;
    }

    static getNextChunk(index, availableChunks, loaded) {
        const nextChunk = (
            /* Trying to find the next index ... */
            find(availableChunks, chunk => chunk.index > index) ||
            /* ... or the leftmost index when end is reached. */
            find(availableChunks, chunk => chunk.index < index)
        );

        if (nextChunk && loaded[nextChunk.index] || false) return nextChunk;

        return null;
    }

}

const mapStateToProps = state => {
    const availableChunks = getAvailableChunks(state);
    const {isDragging, isAnimating, index, animationSpeed: speed} = state;

    return {
        isDragging: Boolean(isDragging),
        availableChunks,
        isAnimating,
        index,
        speed,
    };
};

const mapDispatchToProps = dispatch => ({
    changeIndex: index => dispatch(animationIndex(index)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Animator);
